// extracted by mini-css-extract-plugin
export var divider = "_wt-0";